module.exports = __webpack_public_path__ + "img/abc1.b5e5c21b.png";